import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {OrderClaimInfoState, getInitialState} from '@web/slices/orderClaimInfo/slice'

import {OrderClaimInfoReducers, MakeSliceOptions} from './interfaces'

export default (options?: MakeSliceOptions) =>
    createSlice<OrderClaimInfoState, OrderClaimInfoReducers, 'orderClaimInfo', SliceSelectors<OrderClaimInfoState>>({
        name: 'orderClaimInfo',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            // builder.addCase
            options?.extraReducers?.(builder)
            // builder.addMatcher
        },
    })
